import PropTypes from 'prop-types'
import Markdown from '../../components/Markdown'

const PushedScamItem = ({ scamItem }) => (
  <div className="bg-white shadow-sm rounded px-3 pt-3 pb-1 h-100">
    <div className="d-flex align-items-center mb-2">
      <i className="material-icons text-primary me-2 h2 mb-0">{scamItem.icon}</i>
      <div className="fw-bold h5 m-0 text-black">{scamItem.title}</div>
    </div>
    <Markdown>{scamItem.description}</Markdown>
  </div>
)

PushedScamItem.propTypes = {
  scamItem: PropTypes.instanceOf(Object).isRequired
}

export default PushedScamItem
